import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles.css';

// Global error handler for chunk loading failures
window.addEventListener('error', event => {
  // Check if error is related to chunk loading
  if (
    event.message.includes('Failed to fetch dynamically imported module') ||
    event.message.includes('Importing a module script failed') ||
    event.message.includes('error loading dynamically imported module')
  ) {
    console.error('Chunk loading error detected, reloading page...', event);

    // Attempt to reload the page once to get fresh chunks
    const hasReloaded = sessionStorage.getItem('chunk-reload-attempted');
    if (!hasReloaded) {
      sessionStorage.setItem('chunk-reload-attempted', 'true');
      window.location.reload();
    } else {
      // If already reloaded once, clear the flag and show error
      sessionStorage.removeItem('chunk-reload-attempted');
      console.error('Chunk loading failed after reload attempt');
    }
  }
});

// Clear reload flag on successful page load
window.addEventListener('load', () => {
  sessionStorage.removeItem('chunk-reload-attempted');
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
